import React from "react";
import { Link } from "react-router-dom";
import { appHistory } from "@/router/history";
import { compose } from "helper/compose";
import { withTranslation, type WithTranslation } from "react-i18next";

import FlashMessage from "components/Common/FlashMessage";
import { Button } from "../ui";
import type { UserCustomer } from "../../types/state";
import { withAuthData, type AuthInjectedProps } from "../../context/AuthContext";

interface ChooseCustomerPageOwnProps extends WithTranslation {}

type ChooseCustomerPageProps = ChooseCustomerPageOwnProps & AuthInjectedProps;

type CustomerExtended = UserCustomer & {
  active?: number | string;
  company_code?: string;
};

function ChooseCustomerPage({
  t,
  userLoggedIn,
  userData,
  actions,
  chooseCustomerPageMessage,
}: ChooseCustomerPageProps) {
  React.useEffect(() => {
    if (!userLoggedIn) {
      appHistory.push(BASE_PATH + "/login");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changeCustomer = (id: number | string) => {
    const customers = (userData.customers || []) as CustomerExtended[];
    const customer = customers.find((item) => item.id == id);
    if (customer) {
      actions.changeCustomer(customer);
    }
  };

  const renderCustomerGroup = (
    companyKey: string,
    customers: CustomerExtended[],
    logoClassName: string,
    toneClassName: string,
    description: string
  ) => {
    if (customers.length === 0) {
      return null;
    }

    return (
      <section className="CompanySelector-companyBlock" key={companyKey}>
        <div className="CompanySelector-companyBlockInner">
          <div className={`CompanySelector-companyLogo LogoCompany ${logoClassName}`}></div>
          <p className="CompanySelector-companyDescription">{description}</p>
          <div className="CompanySelector-buttonList">
            {customers.map((customer) => {
              const inactive = customer.active != 1 ? "isInactive" : "";
              return (
                <Button
                  className={`Button CompanySelector-button ${toneClassName} ${inactive}`}
                  key={customer.id}
                  onClick={() => changeCustomer(customer.id)}
                >
                  {customer.id}
                </Button>
              );
            })}
          </div>
        </div>
      </section>
    );
  };

  if (!userLoggedIn) {
    return null;
  }

  const allCustomers = (userData.customers || []) as CustomerExtended[];
  const guinotCustomerList = allCustomers.filter((customer) => customer.company_code === "1000");
  const maryCohrCustomerList = allCustomers.filter((customer) => customer.company_code === "2000");

  return (
    <div className="Page AuthPage ChooseCustomerPageShell">
      <div className="Page-content AuthPage-content">
        <div className="AuthPage-header">
          <div className="LogoCompanyWrapper">
            <Link to={BASE_PATH + "/"}>
              <div className="LogoCompany isSpaced isGMC"></div>
            </Link>
          </div>
          <p className="AuthPage-kicker">{t("topbar.platform_label")}</p>
          <h2 className="Page-title isSpaced">{t("customer.choose.title")}</h2>
          <p className="AuthPage-intro">{t("customer.choose.info")}</p>
        </div>

        <div className="AuthPage-panel ChooseCustomerPage-panel">
          <FlashMessage
            message={chooseCustomerPageMessage}
            className="ChooseCustomerPage-message"
          />
          <div className="CompanySelector">
            <div className="CompanySelector-companyBlockWrapper">
              {renderCustomerGroup(
                "guinot",
                guinotCustomerList,
                "isGuinot",
                "isGuinot",
                t("customer.choose.info_select_guinot")
              )}
              {renderCustomerGroup(
                "marycohr",
                maryCohrCustomerList,
                "isMaryCohr",
                "isMaryCohr",
                t("customer.choose.info_select_marycohr")
              )}
            </div>
          </div>
        </div>

        <Button
          size="lg"
          className="Button isLarge ChooseCustomerPage-logout"
          onClick={actions.logOutUser}
        >
          {t("common.button_disconnect")}
        </Button>
      </div>
    </div>
  );
}

export default compose(withTranslation(), withAuthData)(ChooseCustomerPage);
